<template>
<div class="modalContents__object09">
    <div class="container">
        <div class="row no-gutters">
            <div class="col-lg-7 col-md-8 col-10 mx-auto row no-gutters">
                <p class="col-12 text-center">パスワードの再設定用のリンクを<br>ご登録いただいたメールアドレス宛に<br>送信いたしました。<br><br>メールをご確認の上<br>再設定してください。</p>
                <div class="col-md-8 mx-auto">
                    <a href="javascript:void(0)" class="text-center globalModal--btn" @click="showModalLogin">ログインページへ</a>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
  import { mapMutations } from 'vuex'
  import MultiModalMixin from '../mixins/ModalMixin'

  export default {
    name: "LostPasswordThanks",
    mixins: [MultiModalMixin]
  };
</script>


// WEBPACK FOOTER //
// resources/assets/js/vue/component/modal/lost_password_thanks.vue